/* GASSISA
=========================================================================================
 * Descripción: Menú de acciones del módulo de reimpresión de caja
 * Historial de cambios:
 * ---------------------------------------------------------------------------------------
 *    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1        | 13/04/2026 | Lic. José Luis Aragón Cervantes  | Creación
 * ---------------------------------------------------------------------------------------
 */

import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';

import { Fragment } from "react";

export default function MnuReimpresionCajaActions(props) {
    const { handleClickRegresarMainDashboard } = props;

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
        </Fragment>
    );
}
